<template>
  <div>
    <PageHeader v-if="!isMobile" :title="event.title" />
    <div v-if="event" class="max-w-6xl mx-auto my-0 px-4">
      <div :class="['max-w-2xl mx-auto text-center', isMobile ? 'mt-20' : 'mt-24']">
        <h1 class="text-center">{{ event.title }}</h1>
        <template v-if="event.related_people.length">
          <p v-for="(group, groupIndex) in event.related_people" :key="`group-${groupIndex}`">
            {{ capitalize(group.label) }}
            <span v-for="(person, personIndex) in group.people" :key="`person-${personIndex}`">
              <router-link :to="`/${person.uri.replace('people', 'about')}`">{{ person.title }}</router-link>
              <span v-if="personIndex < group.people.length - 1">, </span>
            </span>
          </p>
        </template>
        <p class="my-4">{{ displayDate }}</p>
        <Tags :tags="event.tags" class="my-4" />
        <div class="w-full relative my-16" :style="calcAspectRatioPadding(event.cover_image)">
          <img
            v-if="event.cover_image"
            class="absolute top-0 left-0 w-full h-full"
            :src="event.cover_image.src"
            :srcset="event.cover_image.srcset"
          />
        </div>
      </div>
      <ContentBlocks :blocks="event.description" />
      <RelatedItems :items="relatedItems" />
    </div>
    <div class="fixed left-0 bottom-0 p-4">
      {{ event.location }}
    </div>
    <PageFooter />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { capitalize, formatDateOrRange, generateMetaTags } from '@/util'
import PageHeader from '@/components/PageHeader'
import Tags from '@/components/Tags'
import ContentBlocks from '@/components/ContentBlocks'
import RelatedItems from '@/components/RelatedItems'
import PageFooter from '@/components/PageFooter'

export default {
  name: 'Event',

  metaInfo () {
    return {
      title: this.pageTitle,
      meta: generateMetaTags(this.pageTitle, this.pageDescription, this.pageImage)
    }
  },

  components: {
    PageHeader,
    Tags,
    ContentBlocks,
    RelatedItems,
    PageFooter
  },

  computed: {
    ...mapState(['events', 'isMobile']),

    pageTitle () {
      return this.event ? this.event.title : null
    },

    pageDescription () {
      return this.event ? this.event.description : null
    },

    pageImage () {
      return this.event && this.event.cover_image ? this.event.cover_image.src : null
    },

    slug () {
      return this.$route.params.slug
    },

    displayDate () {
      return formatDateOrRange(this.event.begin_date, this.event.end_date)
    },

    relatedItems () {
      const activities = this.event.related_activities.map(i => {
        i.type = 'Activity'
        i.date = i.begin_date
        i.dateDisplay = formatDateOrRange(i.begin_date, i.end_date)
        return i
      })

      const artworks = this.event.related_artworks.map(i => {
        i.type = 'Artwork'
        i.date = i.begin_date
        i.dateDisplay = formatDateOrRange(i.begin_date, i.end_date)
        return i
      })      

      return [...activities, ...artworks]
    }
  },

  methods: {
    calcAspectRatioPadding (image) {
      if (!image || !image.dimensions) {
        return ''
      }

      return `padding-top:calc(100%/(${image.dimensions.width}/${image.dimensions.height}));`
    },

    capitalize
  },

  data () {
    return {
      event: false
    }
  },

  async mounted () {
    await this.$store.dispatch('getEvent', this.slug)
    this.event = this.events[this.slug]
    this.$Lazyload.lazyLoadHandler()
  }
}
</script>
